export function formatPhoneNumber(phone) {
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");

  // Format canadien ou US standard : 10 chiffres
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Format +1 international : 11 chiffres commençant par 1
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 ${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  // Format inconnu → retourne tel quel
  return phone;
}
